/**
 * @file  audit/audit.model.ts
 * @description  site audit information
 *
 * @author ogarcia (ozkary)
 *
 */

/**
 * app audit status to track the activity
 */
export enum AuditStatus {
  visit = 'visit',
  timeout = 'timeout',
  abandon = 'abandon',
  complete = 'receipt'
}

/**
 * audit information
 */
export interface Audit {
  id: number;
  status: string;
  created: string;
  updated?: string;
  pageView: string[];
  refId?: string;
  domain: string;
  edition: string;
  token?: string;
}
